const fonts=[
    "Inter"
];

export default fonts;